import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getTableColumns = async (token, params) => {
  const url = 'table_columns'

  const data = await apiGet({ url, params, token })
  return data
}

export function useTableColumns({ params = {}, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getTableColumns(token, params)
  const queryKey = ['table-columns', params]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}
